export const ID = '2a056333-50a1-494f-875c-7680ad684fbd';

export const NAME = 'OMI Widget';
